export const timeFormatter = new Intl.DateTimeFormat('en-US', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
});

export const dateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
});

export const timeSince = (date) => {
  const now = new Date().getTime();

  const seconds = Math.floor((now - date) / 1000);

  let interval = Math.floor(seconds / 31536000);
  let unit;

  if (interval >= 1) {
    unit = `year${interval > 1 ? 's' : ''}`;
    return { interval, unit };
  }

  interval = Math.floor(seconds / 2592000);

  if (interval >= 1) {
    unit = `month${interval > 1 ? 's' : ''}`;
    return { interval, unit };
  }

  interval = Math.floor(seconds / 86400);

  if (interval >= 1) {
    unit = `day${interval > 1 ? 's' : ''}`;
    return { interval, unit };
  }

  interval = Math.floor(seconds / 3600);

  if (interval >= 1) {
    unit = `hour${interval > 1 ? 's' : ''}`;
    return { interval, unit };
  }

  interval = Math.floor(seconds / 60);

  if (interval >= 1) {
    unit = `minute${interval > 1 ? 's' : ''}`;
    return { interval, unit };
  }

  interval = Math.floor(seconds);
  unit = `second${interval > 1 ? 's' : ''}`;

  return { interval, unit };
};
